<template>
  <div>
    Support
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>